<style scoped>
.popup-global-position.k-simple-modal {
  max-height: calc(100vh - 60px);
  width: 90vw;
  top: 30px !important;
  transform: translate(-50%, 0%);
  max-height: calc(100vh - 60px) !important;
  overflow: auto;
  position: fixed;
}

#simple-modal.card-img-overlay {
  position: fixed !important;
}

.close {
  text-align: right;
  margin-bottom: 20px;
  cursor: pointer;
  position: absolute;
  top: 20px;
  right: 20px;
}

.card-body {
  position: relative;
}

.p-tab {
  border-radius: 0 !important;
}
</style>

<template>
  <div v-if="show" id="simple-modal-overlay" class="k-overlay" @click="annulla"></div>
  <div v-if="show" id="simple-modal" class="card-img-overlay popup-global-position k-simple-modal">

    <div class="card mb-4">

      <div class="card-body p-5">
        <div class="close" @click="annulla()">
          <i class="pi pi-times" style="font-size: 20px"></i>
        </div>

        <h4>{{titolo}}</h4>

        <Tabs value="0">
          <TabList>
            <Tab value="0">Messaggio</Tab>
            <Tab value="1">Task Sprint</Tab>
            <Tab value="2">Ticket</Tab>
            <Tab value="3">Lavoro</Tab>
            <Tab value="4">Storia TS</Tab>
          </TabList>
          <TabPanels>
            <TabPanel value="0">
              <h4 class="">Messaggio</h4>
              <pre>{{ notifica.messaggio }}</pre>
            </TabPanel>
            <TabPanel value="1">
              <h4>DOD</h4>
              <pre>{{ notifica.dodTaskSprint }}</pre>
            </TabPanel>
            <TabPanel value="2">
              <h4 class="" v-html="attivita.titolo"></h4>
              <pre v-html="attivita.descrizione"></pre>
            </TabPanel>
            <TabPanel value="3">
              <h4 class="" v-html="lavoro.titolo"></h4>
              <pre v-html="lavoro.descrizione"></pre>
            </TabPanel>
            <TabPanel value="4">
              <DataTable :value="storia" tableStyle="min-width: 50rem">
                <!--    <Column header="Id Task Sprint">-->
                <!--      <template #body="slotProps">-->
                <!--        <p class="m0">-->
                <!--          {{ slotProps.data.idTaskSprint }}-->
                <!--        </p>-->
                <!--      </template>-->
                <!--    </Column>-->
                <Column field="lastUpdate" header="Data" sortable  style="width:150px">

                </Column>
                <Column header="Utente" style="width:150px">
                  <template #body="slotProps">
                    <p>
                      {{ getEsecutore(slotProps?.data?.idUtenteModifica) }}
                    </p>
                  </template>
                </Column>
                <Column header="PM Responsabile" style="width:150px">
                  <template #body="slotProps">
                    <p>
                      {{ getPM(notifica.idTaskSprint) }}
                    </p>
                  </template>
                </Column>
                <Column header="Messaggio" style="width:150px">
                  <template #body="slotProps">
                    <p>
                      {{ slotProps.data.messaggio }}
                    </p>
                  </template>
                </Column>
                <Column header="Esecutore" v-if="visulizzaOwner">
                  <template #body="slotProps">
                    <p class="m0">
                      {{ getEsecutore(slotProps?.data?.idOwner) }}
                    </p>
                  </template>
                </Column>
                <Column header="Stato" style="width:150px">
                  <template #body="slotProps">
                    <p>
                      {{ slotProps.data.status }}
                    </p>
                  </template>
                </Column>
                <Column header="" style="width: 80px; max-width: 80px">
                  <template #body="slotProps">
                    <div class="bottoni-storia">
                      <CustomButton class="dettaglio" @click="visualizzaMessaggio(slotProps?.data)" icon="pi pi-eye" rounded raised />
                    </div>
                  </template>
                </Column>
              </DataTable>
            </TabPanel>

          </TabPanels>
        </Tabs>
      </div>
    </div>
  </div>
  <CustomDialog v-model:visible="showDettaglioStoria" modal :header="headerDettaglio" :style="{ width: '700px' }">
    <pre >{{ bodyDettaglioStoria }}</pre>
    <div class="flex justify-end gap-2" style="grid-gap: 20px; display: flex; margin-top: 20px">
    </div>
  </CustomDialog>
</template>

<script>
import * as $ from 'jquery';
import Tabs from 'primevue/tabs';
import TabList from 'primevue/tablist';
import Tab from 'primevue/tab';
import TabPanels from 'primevue/tabpanels';
import TabPanel from 'primevue/tabpanel';
import CustomButton from "primevue/button";
import DataTable from "primevue/datatable";
import Column from "primevue/column";
import CustomDialog from "primevue/dialog";
export default {
  name: "KModalDettaglioNotifica",
  components: {CustomDialog, CustomButton, Tabs, TabList, Tab, TabPanels, TabPanel, DataTable,Column },

  data() {
    return {
      show: false,
      notifica:{},
      lavoro:null,
      attivita:null,
      esecutore:'',
      titolo:'',
      storia:[],
      visulizzaOwner:false,
      showDettaglioStoria:false,
      bodyDettaglioStoria:'',
      headerDettaglio:'',
      fromTutteLeNotifiche:false
    }
  },
  created() {
    $(document).keyup(function (e) {
      if (e.key === "Escape" && this.show) {
        this.annulla()
      }
    }.bind(this));
    this.$store.subscribe((mutation, state) => {
      if (mutation.type === 'showDettaglioNotifica') {
        $('html').css('overflow', 'hidden')
        this.show = true;
        this.notifica=mutation.payload.notifica
        this.lavoro=mutation.payload.lavoro
        this.attivita=mutation.payload.attivita
        this.esecutore=mutation.payload.esecutore
        this.titolo=mutation.payload.titolo;
        this.fromTutteLeNotifiche=mutation.payload.fromTutteLeNotifiche
        this.$store.dispatch('loadStoriaTaskFromNotifica', { idTaskSprint: this.notifica.idTaskSprint, titoloLavoro: this.notifica.titoloLavoro, titoloAttivita: this.notifica.titoloAttivita });
      }
      if(mutation.type==='visualizzaStoriaTSFromNotifica'){
        //this.titolo="Storico del Task per l'attività: "+mutation.payload.titoloAttivita+" e lavoro "+mutation.payload.titoloLavoro
        this.visulizzaOwner=mutation.payload.visulizzaOwner
        this.storia=[...mutation.payload.storico];
      }
    });
  },
  methods: {
    annulla() {
      this.show = false;
      this.titoloTicket = '';
      this.descrizioneTicket = '';
      this.titoloLavoro = '';
      this.descrizioneLavoro = '';
      this.altriDettagli = ''
      $('html').css('overflow', 'auto')
      if(this.fromTutteLeNotifiche){
        this.$store.dispatch("reopenTutteLeNotifiche")
      }
    },
    getEsecutore(idEsecutore){
      if(!idEsecutore){
        return ''
      }
      if(idEsecutore==-1){
        return 'SYS'
      }
      let esecutore=this.$store.getters.getEsecutoriFilter(""+idEsecutore);
      if(!esecutore || esecutore.length <= 0){
        return ''
      }else{
        return esecutore[0].descrizione;
      }
    },
    visualizzaMessaggio(storiaTask){
      this.showDettaglioStoria=true;
      let es=this.getEsecutore(storiaTask?.idUtenteModifica);
      this.headerDettaglio='Messaggio di '+ es+ ' creato il '+storiaTask.lastUpdate
      this.bodyDettaglioStoria=storiaTask.messaggio;
    },

    getPM(idTaskSprint){
      let ts=this.$store.getters.getTaskById(idTaskSprint);
      if(ts && ts[0].idPM){
        return this.getEsecutore(ts[0].idPM)
      }else{
        return ''
      }
    }
  }
}
</script>